<template>
  <div>
    <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
      <ls-card ref="refBaseInfo">
        <template #title>基础信息</template>
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="流程单号">
              <a-input v-model="detail.billNo" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="流程名称">
              <a-input v-model="detail.formName" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申请人">
              <a-input v-model="detail.realName" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申请时间">
              <a-input v-model="detail.applyTime" disabled />
            </a-form-item>
          </a-col>
        </a-row>
      </ls-card>
      <ls-card ref="refDetailTable">
        <template #title>
          <span>详细信息</span>
          <a-button type="primary" class="ml10" @click="handleBatchApprove" :disabled="detail.status === 'APPROVED' || detail.status === 'REJECTED'">批准</a-button>
          <a-button type="danger" class="ml10" @click="handleBatchReject" :disabled="detail.status === 'APPROVED' || detail.status === 'REJECTED'">拒绝</a-button>
        </template>
        <!-- <ls-api-table
          ref="dataTable"
          :columns="columns"
          :data-source="tableDataSource"
          rowKey="serialNumber"
          :scroll="{ x: 2500, y: detailTableHeight }"
          :height="detailTableHeight"
          :tableProps="{}"
          :pagination="false"
        >
          <template slot="approvalStatus" slot-scope="{record}">
            <div class="approval-status">
              <a-select v-model="record.approvalStatusTwo" :disabled="detail.status === 'APPROVED' || detail.status === 'REJECTED'">
                <a-select-option key="APPROVED">批准</a-select-option>
                <a-select-option key="REJECTED">拒绝</a-select-option>
              </a-select>
            </div>
          </template>
        </ls-api-table> -->
        <a-table
          ref="dataTable"
          :columns="columns"
          :data-source="tableDataSource"
          rowKey="serialNumber"
          :scroll="{ x: 2500, y: detailTableHeight + 52 }"
          :pagination="false"
        >
          <template slot="approvalStatus" slot-scope="text, record">
            <div class="approval-status">
              <a-select v-model="record.approvalStatusTwo" :disabled="detail.status === 'APPROVED' || detail.status === 'REJECTED'">
                <a-select-option key="APPROVED">批准</a-select-option>
                <a-select-option key="REJECTED">拒绝</a-select-option>
              </a-select>
            </div>
          </template>
        </a-table>
      </ls-card>
      <ls-card ref="refApprovalArea">
        <template #title>审批</template>
        <a-row>
          <a-col :md="24" :sm="24">
            <a-button type="primary" :disabled="detail.status === 'APPROVED' || detail.status === 'REJECTED'" :loading="btnLoading" @click="handleRatify">提交</a-button>
          </a-col>
          <a-col :md="24" :sm="24" class="mt10 mb10 approval-input">
            <a-form-item label="审批意见" :labelCol="{ style: { width: '150px' } }">
              <a-input v-model="detail.comment" :disabled="detail.status === 'APPROVED' || detail.status === 'REJECTED'" />
            </a-form-item>
          </a-col>
        </a-row>
      </ls-card>
    </a-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { apiMesFlowPathLineOrderApprovalList, apiKernelFlowExternalBpm, apiMesFlowOrderApprovalHeader } from '@/api/approval/approval-process'

import md5 from 'md5'
export default {
  // eslint-disable-next-line
  name: 'approval-process-detail', // name要和菜单路由保存一致
  components: {},
  data () {
    return {
      btnLoading: false, // 按钮loading
      detail: {
        billNo: "",
        formName: "",
        realName: "",
        applyTime: "",
        comment: ""
      },
      tableDataSource: [],
      // tableProps: {
      //   requestApi: generateLsTableResData(apiMesFlowPathLineOrderApprovalList, true),
      //   requestParam: { pageSize: 9999 },
      //   pageCurrent: true
      // },
      queryParams: {},
      columns: [
        {
          title: '审批',
          dataIndex: 'approvalStatus',
          align: 'center',
          scopedSlots: { customRender: 'approvalStatus' },
          fixed: 'left',
          width: 120
        },
        {
          title: '加工组织',
          dataIndex: 'desOrganizationName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '工单状态',
          dataIndex: 'statusName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '审批状态',
          dataIndex: 'approvalStatusName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '成品',
          dataIndex: 'assemblyItemId',
          align: 'center',
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '工单类型',
          dataIndex: 'jobTypeName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '工单分类',
          dataIndex: 'classCode',
          align: 'center',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'primaryUom',
          align: 'center',
          ellipsis: true
        },
        {
          title: '计划数量',
          dataIndex: 'planQuantity',
          align: 'center',
          ellipsis: true
        },
        {
          title: '车间',
          dataIndex: 'workCode',
          align: 'center',
          ellipsis: true
        },
        {
          title: '产线',
          dataIndex: 'lineId',
          align: 'center',
          ellipsis: true
        },
        {
          title: '计划开始时间',
          dataIndex: 'scheduledStartDate',
          scopedSlots: { customRender: 'scheduledStartDate' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '计划完成时间',
          dataIndex: 'scheduledCompletionDate',
          scopedSlots: { customRender: 'scheduledCompletionDate' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '下达时间',
          dataIndex: 'releaseDate',
          scopedSlots: { customRender: 'releaseDate' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '交货时间',
          dataIndex: 'deliveryDate',
          scopedSlots: { customRender: 'deliveryDate' },
          width: 170,
          align: 'center',
          type: "text"
        },
        {
          title: '备注',
          dataIndex: 'remarks',
          align: 'center',
          ellipsis: true
        }
      ],
      headId: '',
      detailTableHeight: 300,
      detailPrevious: null,
      approvalLoading: false,
      rejectLoading: false
    }
  },
  computed: {
    ...mapState({
      jobCode: (state) => state.user.jobCode
    })
  },
  created () {
    this.btnLoading = false
    this.headId = this.$route.query.bpmBillNo
    apiMesFlowOrderApprovalHeader({ headId: this.headId }).then(res => {
      console.log(res)
      this.detail = res.data
    })
    this.queryParams.headId = this.headId || null
    apiMesFlowPathLineOrderApprovalList({ headId: this.headId, pageSize: 9999999 }).then(res => {
      console.log(res)
      if (res.code === 200) {
        this.tableDataSource = res.rows
        this.tableDataSource.forEach(item => {
          this.$set(item, 'approvalStatusTwo', this.detail?.status === 'APPROVED' || this.detail?.status === 'REJECTED' ? item?.approvalStatus : '')
        })
      } else {
        this.tableDataSource = []
      }
    })
  },
  mounted () {
    this.initDetailTableAreaHeight()
  },
  methods: {
    initDetailTableAreaHeight () {
      console.log(this.$refs.refBaseInfo.$el.offsetHeight)
      console.log(this.$refs.refApprovalArea.$el.offsetHeight)
      const viewportHeight = window.innerHeight;
      this.detailTableHeight = viewportHeight - this.$refs.refBaseInfo.$el.offsetHeight - this.$refs.refApprovalArea.$el.offsetHeight - 208
    },
    examineAndApprove (val) {
      const apiKey = process.env.VUE_APP_API_SCM_GYL_URL_api_key
      const apiSecret = process.env.VUE_APP_API_SCM_GYL_URL_api_secret
      const timestamp = new Date().getTime()
      const sign = md5(apiKey.toString() + timestamp.toString() + apiSecret.toString());
      const url = `${process.env.VUE_APP_API_SCM_GYL_URL}/api/kernel-flow/external/bpm/approveProcess?apiKey=${apiKey}&apiSecret=${apiSecret}&timestamp=${timestamp}&sign=${sign}`
      const params = {
        assignee: this.jobCode, // 当前登陆用户
        billNo: this.detail.billNo, // 单号
        processCode: this.detail.processCoding, // 流程编码
        variables: {
          billRowId: this.headId,
          approvalRemarks: this.detail.comment || "",
          approveList: this.tableDataSource.map(item => {
            return { wipEntityId: item.wipEntityId, approvalStatus: item.approvalStatusTwo }
          })
        }
      }
      this.btnLoading = true
      apiKernelFlowExternalBpm(url, params).then(res => {
        if (val === "APPROVED" && res.state === 100) {
          this.$message.success("批准成功")
          setTimeout(() => {
            this.approvalLoading = false
            this.handleClose()
          }, 2000)
        } else if (val === "REJECTED" && res.state === 100) {
          this.$message.success("拒绝成功")
          setTimeout(() => {
            this.rejectLoading = false
            this.handleClose()
          }, 2000)
        } else {
          this.$message.error(res.msg)
          this.approvalLoading = false
          this.rejectLoading = false
        }
      }).catch(e => {
        this.approvalLoading = false
        this.rejectLoading = false
      }).finally(() => {
        this.btnLoading = false
      })
    },
    requestRefuse () {
      const url = `${process.env.VUE_APP_API_SCM_GYL_URL}/api/raptor-wms-single/inventory/terminate`
      const params = {
        billNo: this.detail.billNo, // 单号
        approvalComments: this.detail.comment || "",
        status: "REJECTED",
        user: this.jobCode // 当前登陆用户
      }
      apiKernelFlowExternalBpm(url, params).then(res => {
        if (res.success) {
          this.$message.success("拒绝成功")
          setTimeout(() => {
            this.handleClose()
          }, 2000)
        } else {
          this.$message.error(res.msg)
        }
        this.rejectLoading = false
      }).catch(e => {
        this.rejectLoading = false
      })
    },
    // 批准
    handleRatify () {
      if(this.tableDataSource?.find(v => { return !v.approvalStatusTwo })) {
        this.$message.warning("请选择审批结果")
        return false
      }
      this.approvalLoading = true
      this.examineAndApprove("APPROVED")
    },
    // 拒绝
    handleRefuse () {
      this.rejectLoading = true
      if (Number(this.detail.type) === 3) {
        this.requestRefuse()
      } else {
        this.examineAndApprove("REJECTED")
      }
    },
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    handleClose () {
      this.event.$emit("close-current-page");
    },
    handleBatchApprove () {
      this.tableDataSource.forEach(item => {
        this.$set(item, 'approvalStatusTwo', 'APPROVED')
      })
    },
    handleBatchReject () {
      this.tableDataSource.forEach(item => {
        this.$set(item, 'approvalStatusTwo', 'REJECTED')
      })
    }
  }
}
</script>

<style scoped lang="less">
.approval-status {
  /deep/.ant-select {
    width: 100%;
  }
}
input {
  width: 170px;
}
/deep/.ant-input-number{
  width: 170px;
}
/deep/.ant-calendar-picker{
  width: 150px;
}
.approval-input {
  input {
    width: 400px;
  }
}
</style>
